import type { DisplayStatus } from '../../../../../helper/PaymentUtils';

interface StatusBadgeProps {
  status: DisplayStatus;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  let bgColor = 'bg-gray-100';
  let textColor = 'text-gray-600';
  let displayStatusText: string = status;
  switch (status) {
    case 'Unpaid':
      bgColor = 'bg-orange-100';
      textColor = 'text-orange-700';
      displayStatusText = 'Unbezahlt';
      break;
    case 'Paid':
      bgColor = 'bg-green-100';
      textColor = 'text-green-700';
      displayStatusText = 'Bezahlt';
      break;
    case 'Started':
      bgColor = 'bg-yellow-100';
      textColor = 'text-yellow-700';
      displayStatusText = 'Zahlung unvollständig';
      break;
    case 'Refunded':
      bgColor = 'bg-blue-100';
      textColor = 'text-blue-700';
      displayStatusText = 'Zurückerstattet';
      break;
    case 'Expired':
      bgColor = 'bg-red-100';
      textColor = 'text-red-700';
      displayStatusText = 'Abgelaufen/Fehlgeschlagen';
      break;
    case 'Unknown':
    default:
      displayStatusText = 'Unbekannt';
      break;
  }

  return (
    <span
      role='status'
      aria-label={`Zahlungsstatus: ${displayStatusText}`}
      className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${bgColor} ${textColor}`}
    >
      {displayStatusText}
    </span>
  );
};
